import * as z from "zod";

const PaymentBaseSchema = z.object({
  agreedBuyerPricePrUnit: z
    .string({
      required_error: "validation:priceRequired",
      invalid_type_error: "validation:priceRequired",
    })
    .min(1, "validation:priceRequired"),
  currencyType: z.string({
    required_error: "validation:currencyRequired",
    invalid_type_error: "validation:currencyRequired",
  }),
  priceUnitId: z.number({
    required_error: "validation:unitRequired",
    invalid_type_error: "validation:unitRequired",
  }),
  agreedSellerPricePrUnit: z
    .string({
      required_error: "validation:priceRequired",
      invalid_type_error: "validation:priceRequired",
    })
    .min(1, "validation:priceRequired"),
  invoiceDueDateId: z.object(
    {
      id: z.number({
        required_error: "validation:invoiceDueDateRequired",
        invalid_type_error: "validation:invoiceDueDateRequired",
      }),
      days: z.number(),
    },
    {
      invalid_type_error: "validation:invoiceDueDateRequired",
    }
  ),
  isPaymentReceiverInverted: z.boolean(),
  skipInvoicing: z.boolean(),
  indexRegulated: z.boolean(),
});

export const PaymentSchema = PaymentBaseSchema;
export type PaymentInput = z.infer<typeof PaymentSchema>;
